/* eslint-disable */
import React, { useEffect, useState } from 'react';
import './styles.scss';
import InventoryBaseMealCategory from '../inventory-base-meal-category';
import { SocketIOConnection } from 'utils/socket_client';
import { IBaseInventoryItem } from '../inventory-base-meal-item/types';

type SocketMessageType = {
  cokitchen_id: string;
  brand_id: string;
  base_meal_quantity: {
    [key: string]: string;
  };
};

const InventoryBaseMeal = ({
  meals = [],
  brandName,
  brandId,
  cokitchenId
}: {
  meals: any;
  brandName: any;
  brandId: string;
  cokitchenId: string;
}) => {
  const [allMeals, setAllMeals] = useState<IBaseInventoryItem[]>([]);

  useEffect(() => {
    setAllMeals(meals);
  }, []);
  useEffect(() => {
    if (!brandId || !cokitchenId) return;
    connectSocket();
  }, [brandId, cokitchenId]);
  const updateQuantity = async (data: SocketMessageType) => {
    setAllMeals((prev) => {
      const newMeals = [...prev];
      newMeals?.map((meal, i) => {
        Object.keys(data?.base_meal_quantity)?.map((k: string) => {
          if (k === meal?.base_meal_id) {
            console.log(data?.base_meal_quantity[k], 'quantity');
            newMeals[i].quantity = data?.base_meal_quantity[k];
          }
        });
      });
      return [...newMeals];
    });
  };

  const connectSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    const roomName = `quantity-updated-${cokitchenId}:${brandId}`;
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
    });

    conn.addEventListener(roomName, 'quantity-updated', (data: SocketMessageType) => {
      updateQuantity(data);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };

  return <InventoryBaseMealCategory category={allMeals} brandName={brandName} />;
};

export default InventoryBaseMeal;
